<template>
  <div class="number-interval d-flex flex-column">
    <el-tooltip :content="fromPlaceholder" placement="top" effect="light" :open-delay="300" transition="el-zoom-in-top">
      <el-input-number :data-id="`${dataId}-from`" :controls="false" v-model="from" @input="onInput" @change="onChange" ref="from" :placeholder="fromPlaceholder" />
    </el-tooltip>
    <el-tooltip
      :content="toPlaceholder"
      placement="bottom"
      effect="light"
      :open-delay="300"
      transition="el-zoom-in-top"
    >
      <el-input-number :data-id="`${dataId}-to`" :controls="false" v-model="to" @input="onInput" @change="onChange" ref="to" :placeholder="toPlaceholder" />
    </el-tooltip>
  </div>
</template>

<script>
import { debounce, get } from 'lodash'

export default {
  name: 'FilterNumber',
  props: {
    field: {
      type: Object,
      required: true,
    },
    dataId: {
      type: String,
    }
  },
  data() {
    return {
      fromPlaceholder: this.$i18n.t(`number_interval_from`),
      toPlaceholder: this.$i18n.t(`number_interval_to`),
    }
  },
  computed: {
    from: {
      get() {
        return get(this.$get('columnFilter')(this.field.data, {}), 'from')
      },
      set(from) {
        const interval = {}
        if (from) interval.from = from
        if (this.to) interval.to = this.to
        this.$dispatch('setFilter', {
          data: this.field.data,
          filter: interval,
        })
      },
    },
    to: {
      get() {
        return get(this.$get('columnFilter')(this.field.data, {}), 'to')
      },
      set(to) {
        const interval = {}
        if (this.from) interval.from = this.from
        if (to) interval.to = to
        this.$dispatch('setFilter', {
          data: this.field.data,
          filter: interval,
        })
      },
    },
  },
  methods: {
    onChange() {
      this.$dispatch('setSearchTrigger', { searchTrigger: 'filter' })
    },
    onInput: debounce(function () {
      this.$emit('apply-filter')
    }, 500),
  },
}
</script>
